import { render, staticRenderFns } from "./industry_report.vue?vue&type=template&id=5506a891&scoped=true"
import script from "./industry_report.vue?vue&type=script&lang=js"
export * from "./industry_report.vue?vue&type=script&lang=js"
import style0 from "./industry_report.vue?vue&type=style&index=0&id=5506a891&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5506a891",
  null
  
)

export default component.exports